import { LocaleSwitcher } from './index';
import { useLocale } from 'hooks/use-locale';
import type { TenantId } from 'tenants/types/tenant';

type LocaleSwitcherContainerProps = {
  tenantId: TenantId;
};

export function LocaleSwitcherContainer({ tenantId }: LocaleSwitcherContainerProps) {
  const { 
    isEnabled, 
    isReady, 
    currentLocale, 
    localeOptions, 
    changeLocale, 
  } = useLocale(tenantId);

  return (
    <LocaleSwitcher
      shouldRender={isEnabled && isReady}
      currentLocale={currentLocale}
      localeOptions={localeOptions}
      changeLocale={changeLocale}
    />
  );
} 